import { Link } from 'react-router-dom';

/**
 * Fixed top bar: one-click home from every page that uses AppShell (all routes except `/`).
 */
export default function SiteHeader() {
  return (
    <header className="fixed top-0 left-0 right-0 z-[60] border-b border-stone-200/80 bg-white/95 backdrop-blur-md shadow-sm">
      <div className="mx-auto flex h-14 max-w-7xl items-center justify-between gap-3 px-4 sm:px-6">
        <Link
          to="/"
          className="flex min-w-0 items-center gap-2 rounded-xl py-1 pr-2 text-stone-900 transition hover:bg-stone-100/80"
          aria-label="Frequency Locus home"
        >
          <img
            src="/logo.png"
            alt=""
            className="h-9 w-9 shrink-0 rounded-full object-contain bg-stone-100 p-0.5"
          />
          <span className="truncate font-semibold text-stone-800" style={{ fontFamily: 'Ubuntu, sans-serif' }}>
            Frequency Locus
          </span>
        </Link>
        <Link
          to="/"
          className="shrink-0 rounded-full bg-[#6B3B18] px-4 py-2 text-sm font-semibold text-white shadow-sm hover:opacity-95"
        >
          Home
        </Link>
      </div>
    </header>
  );
}
